import { render, staticRenderFns } from "./GeneralSettingsGlobalStandbyTimeframe.vue?vue&type=template&id=14c4b516&"
import script from "./GeneralSettingsGlobalStandbyTimeframe.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsGlobalStandbyTimeframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VCombobox,VRow})
